import React from 'react'
import axios from "axios";
import {useNavigate} from "react-router-dom";
import {errorToast, successToast} from "../../components/layout/ToastStyles";
import {Apis} from "../../util/data";
import {PageBackLabel} from "../../components/layout/PageBackLabel";
import PageSection from "../../components/layout/PageSection";
import PageTitle from "../../components/layout/PageTitle";
import PageContainer from "../../components/layout/PageContainer";
import HorarioForm from "./HorarioForm";


const HorarioNew = () => {
  const navigate = useNavigate()

  const onCreate = async (horario) => {
    horario.fechaInicio = horario.fechaInicio + "T00:00:00-05:00";
    horario.fechaFin = horario.fechaFin + "T00:00:00-05:00"
    horario.horaInicio = horario.horaInicio.length === 5 ? horario.horaInicio + ":00" : horario.horaInicio
    horario.horaFin = horario.horaFin.length === 5 ? horario.horaFin + ":00" : horario.horaFin
    await axios.post(Apis.PROD + '/horario-atencion/new',horario)
      .then(res => {
        successToast("Horario creado correctamente")
        navigate('/horario')
      })
      .catch(err => {
        errorToast(err.response.data.message,6000)
      });
  }

  return (
    <PageContainer>
      <PageSection>
        <PageBackLabel text='Horarios' onClick={() => navigate('/horario')}/>
        <PageTitle title={'Horario de atención nuevo'}/>
      </PageSection>

      <PageSection>
        <HorarioForm value={{}} onSubmit={(horario) => onCreate(horario)}/>
      </PageSection>
    </PageContainer>
  )
}

export default HorarioNew;
